import React, { useState, useEffect } from 'react';
import logo from '../../assets/blinkscribe.png';
import bmlogo from '../../assets/bm_logo-removebg-preview.png';
import './PreviewAnimation.css';

const PreviewAnimation = ({ status }) => {
  const sections = [
    { title: 'Chief Complaints', content: '' },
    { title: 'History of Present Illness', content: '' },
    { title: 'Review of Systems', content: '' },
    { title: 'Physical Examination', content: '' },
    { title: 'Assessment', content: '' },
    { title: 'Plan', content: '' }
  ];

  const [visibleSections, setVisibleSections] = useState([]);

  useEffect(() => {
    if (status) {
      let index = 0;
      const interval = setInterval(() => {
        if (index < sections.length) {
          setVisibleSections((prev) => [...prev, sections[index]]);
          index++;
        } else {
          clearInterval(interval);
        }
      }, 800);
      return () => clearInterval(interval);
    } else {
      setVisibleSections(sections); // instantly show all if status is false
    }
  }, [status]);

  const renderSection = (section, index) => (
    <div
      key={section?.title}
      className={`flex flex-col text-start w-full ${
        status ? (index < visibleSections.length ? 'fade-in' : 'semi-visible') : ''
      }`}
    >
      <p
        className="text-xs mb-1"
        dangerouslySetInnerHTML={{
          __html: `<strong>${section?.title}:</strong><br>`,
        }}
      ></p>
      <p
        className="text-xs text-gray-600 break-words overflow-hidden max-w-full"
        dangerouslySetInnerHTML={{
          __html: `${section?.content.replace(/\n/g, '<br>')}<br><br>`,
        }}
      ></p>
    </div>
  );

  return (
    <div className="flex flex-col items-start w-full bg-white shadow-lg border border-gray-300 rounded-xl p-6 relative">
      <div className="flex flex-col items-start w-full bg-[#f5f5f559] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] h-[500px] p-4 border border-gray-300 rounded-lg min-h-0 relative overflow-hidden">
        
        {/* Scanner Effect Only When status is true */}
        {status && <div className="scanner-overlay"></div>}

        {/* Header with Logo */}
        {/* <div className="flex items-center justify-center w-full">
          <img src={logo} alt="logo" className="h-6" />
        </div> */}

        {/* <div className="w-full mt-4">
          <hr className="w-full border-t-2 border-gray-300 my-2" />
        </div> */}

        {/* Content */}
        <div className="flex-1 flex flex-col overflow-auto justify-between  w-full mt-4 custom-scrollbar">
          {visibleSections.map((section, index) => renderSection(section, index))}
        </div>

        {/* Footer */}
        {/* <div className="mt-6 w-full flex flex-col gap-2 items-center justify-center">
          <div className="text-xs font-medium [font-family:'Poppins-Medium',Helvetica] text-black tracking-[0] leading-[normal] whitespace-nowrap text-center">
            Generated By
          </div>
          <img src={bmlogo} alt="logo" className="h-6" />
        </div> */}
      </div>
    </div>
  );
};

export default PreviewAnimation;
